import React from 'react';
import { Box, Switch, Typography } from '@mui/material';
import { ControlModeTemplateField } from '@src/types/ControlModes';
import { FormValue } from '../../context/formReducer';

interface BooleanFieldProps {
  field: ControlModeTemplateField;
  fieldValue: FormValue | undefined;
  hasError: boolean;
  errorMessage: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const BooleanField: React.FC<BooleanFieldProps> = ({
  field,
  fieldValue,
  hasError,
  errorMessage,
  handleChange,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Switch
          name={field.controllerField}
          checked={
            fieldValue === true ||
            fieldValue === 'true' ||
            ((fieldValue === undefined || fieldValue === null) &&
              (field.defaultValue === true || field.defaultValue === 'true'))
          }
          onChange={handleChange}
          size='small'
          sx={{
            marginRight: '160px',
          }}
          color={hasError ? 'error' : 'primary'}
        />
      </Box>
      {hasError && (
        <Typography variant='caption' color='error'>
          {errorMessage}
        </Typography>
      )}
    </Box>
  );
};

export default BooleanField;
